// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"570141cf","853":"cf6745d6","896":"28684d69","902":"ff8bcadf","997":"0ee7480d"}[chunkId] + ".chunk.js";
};